<template>
    <div>
        <modal-component
            :id="sourceType"
            :visible="visible"
            :size="`lg`"
            :title="title"
            @close="$emit(`close`)"
        >
            <div class="p-3">
                <div class="row my-4" v-for="(f, i) in fundingSources">
                    <div class="d-flex justify-content-between w-100">
                        <h4 class="mr-auto">{{ f.name }}</h4>
                        <span class="text-dark font-weight-bold text-nowrap mr-3 small"
                            >Submit Expire: {{ f.claims_submit_by_days }} days</span
                        >
                        <span class="text-dark font-weight-bold text-nowrap small"
                            >Appeal Expire: {{ f.claims_appeal_by_days }} days</span
                        >
                    </div>
                    <table class="w-100 overflow-x-scroll">
                        <thead>
                            <tr class="table-header">
                                <th style="width: 12%" class="text-white small">CPT Code</th>
                                <th style="width: 32%" class="text-white small">Titles</th>
                                <th style="width: 32%" class="text-white small">Nickname</th>
                                <th style="width: 8%" class="text-white small">
                                    Unit Size (Minutes)
                                </th>
                                <th style="width: 8%" class="text-white small">Expected Rate $</th>
                                <th style="width: 8%" class="text-white small">Charge Rate $</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(expected_payment, index) in f.expected_payments">
                                <!--Todo: Fix and retrieve the code and nickname-->
                                <td>
                                    <span
                                        class="small"
                                        v-if="getCptCode(expected_payment.cpt_code_id)"
                                    >
                                        {{ getCptCode(expected_payment.cpt_code_id).code }}
                                    </span>
                                </td>
                                <td>
                                    <select
                                        class="form-control form-control-sm"
                                        v-if="
                                            f.isEditing &&
                                                expected_payment.hasOwnProperty('therapist_types')
                                        "
                                        multiple
                                        name="therapist_types"
                                        id="therapist_types"
                                        v-model="expected_payment.therapist_types"
                                    >
                                        <option
                                            :value="type.id"
                                            v-for="type in therapistTypes"
                                            :disabled="
                                                !expected_payment.therapist_types.includes(
                                                    type.id
                                                ) &&
                                                    selectedCodeTypeCombination.find(
                                                        c =>
                                                            c.therapist_type === type &&
                                                            c.cpt_code_id ===
                                                                expected_payment.cpt_code_id
                                                    )
                                            "
                                            >{{ type.title }}</option
                                        >
                                    </select>
                                    <span
                                        class="small"
                                        v-tooltip="
                                            getTherapistTypes(expected_payment.cpt_code_id).long
                                        "
                                    >
                                        {{ getTherapistTypes(expected_payment.cpt_code_id).short }}
                                    </span>
                                </td>
                                <td>
                                    <span
                                        class="small"
                                        v-if="getCptCode(expected_payment.cpt_code_id)"
                                    >
                                        {{
                                            getCptCode(expected_payment.cpt_code_id)
                                                .service_nickname
                                        }}
                                    </span>
                                </td>
                                <td>
                                    <input
                                        :id="`cpt-${expected_payment.cpt_code_id}-expected-minutes`"
                                        v-mask="'####'"
                                        v-show="f.isEditing"
                                        class="form-control form-control-sm"
                                        type="text"
                                        v-if="expected_payment"
                                        v-model="expected_payment.minutes"
                                    />
                                    <span
                                        class="small"
                                        v-show="!f.isEditing && expected_payment.minutes"
                                        >{{ expected_payment.minutes }}</span
                                    >
                                </td>
                                <td>
                                    <input
                                        :id="
                                            `cpt-${
                                                expected_payment.cpt_code_id
                                            }-expected-expected_rate`
                                        "
                                        v-show="f.isEditing"
                                        class="form-control form-control-sm"
                                        type="text"
                                        v-if="expected_payment"
                                        v-model="expected_payment.expected_rate"
                                    />
                                    <span
                                        class="small"
                                        v-show="!f.isEditing && expected_payment.expected_rate"
                                        >{{ expected_payment.expected_rate }}</span
                                    >
                                </td>
                                <td>
                                    <input
                                        :id="
                                            `cpt-${
                                                expected_payment.cpt_code_id
                                            }-expected-charge_rate`
                                        "
                                        v-show="f.isEditing"
                                        type="text"
                                        class="form-control form-control-sm"
                                        v-if="expected_payment"
                                        v-model="expected_payment.charge_rate"
                                    />
                                    <span
                                        class="small"
                                        v-show="!f.isEditing && expected_payment.charge_rate"
                                        >{{ expected_payment.charge_rate }}</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="w-100 d-flex justify-content-end">
                        <button
                            class="btn btn-primary btn-sm m-2"
                            v-if="!f.isEditing"
                            @click="editExpectedPayment(f)"
                        >
                            Edit
                        </button>
                        <button
                            :disabled="f.loading"
                            class="btn btn-primary btn-sm m-2"
                            v-if="f.isEditing"
                            @click="saveExpectedPayment(f)"
                        >
                            <span v-if="!f.loading">Save</span
                            ><i v-if="f.loading" class="fa fa-spin fa-circle-o-notch mr-3"></i>
                        </button>
                    </div>

                    <template v-if="f.errors">
                        <div class="mt-2">
                            <div v-for="error in Object.keys(f.errors)" class="alert alert-danger">
                                <a href="#" class="close" data-dismiss="alert">&times;</a>
                                <strong>Error!</strong>
                                <span class="text-capitalize">{{ error.replace(/\s+/g, " ") }}</span
                                >:
                                <span class="comma-list" v-for="e in f.errors[error]">{{ e }}</span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </modal-component>
    </div>
</template>

<script>
import ModalComponent from "../ui/ModalComponent";

export default {
    name: "ExpectedPayments",
    props: ["organization", "sourceType", "fundingSources", "visible", "title", "codes"],
    components: { ModalComponent },

    data() {
        return {
            isInitialized: false,
            therapistTypes: this.$parent.$parent.therapistTypes,
        };
    },

    watch: {
        fundingSources() {
            this.initialize();
        },
        cptCodes() {
            this.initialize();
        },
        serviceCodes() {
            this.initialize();
        },
    },

    methods: {
        initialize() {
            if (
                this.fundingSources &&
                this.fundingSources.length &&
                this.codes &&
                this.codes.length &&
                !this.isInitialized
            ) {
                this.setupCodes();
            }
        },

        getCptCode(id) {
            return this.codes.find(cpt_code => {
                return id === cpt_code.id;
            });
        },

        getTherapistTypes(id) {
            let code = this.getCptCode(id);
            if (code && code.therapist_types && code.therapist_types.length) {
                let length = code.therapist_types.length;
                if (length === 1) {
                    return {
                        short: code.therapist_types[0], //TODO: this assumes `code.therapist_types` is an array of strings
                        long: null,
                    };
                }
                let long = "";
                code.therapist_types.forEach(type => (long = long + (long ? ", " : "") + type));
                return {
                    short: code.therapist_types[0] + ` + ${length - 1} more`,
                    long,
                };
            }
            return {
                short: "No title",
                long: null,
            };
        },

        setupCodes() {
            this.fundingSources.map(source => {
                let expected_payments = [];
                this.codes.forEach(cpt => {
                    if (source.expected_payments[cpt.id]) {
                        let existing_cpt = source.expected_payments[cpt.id];
                        existing_cpt.cpt_code_id = cpt.id;
                        expected_payments.push(existing_cpt);
                    } else {
                        expected_payments.push({
                            cpt_code_id: cpt.id,
                            expected_rate: "",
                            charge_rate: "",
                            minutes: "",
                        });
                    }
                });
                source.expected_payments = expected_payments;
            });
            this.isInitialized = true;
        },

        editExpectedPayment(funding_source) {
            Vue.set(funding_source, "isEditing", true);
        },

        saveExpectedPayment(funding_source) {
            Vue.delete(funding_source, "errors");
            let valid_expected_payments = [];
            funding_source.expected_payments.forEach(expected_payment => {
                if (
                    expected_payment.expected_rate ||
                    expected_payment.charge_rate ||
                    expected_payment.minutes
                ) {
                    valid_expected_payments.push(expected_payment);
                }
            });
            let payload = {};
            payload.expected_payments = valid_expected_payments;

            Vue.set(funding_source, "loading", true);

            axios
                .patch(
                    `/api/organizations/${this.organization.id}/funding/sources/${
                        funding_source.id
                    }`,
                    payload
                )
                .then(r => {
                    Vue.delete(funding_source, "isEditing");
                    Vue.delete(funding_source, "loading");
                })
                .catch(e => {
                    console.error(e);
                    Vue.delete(funding_source, "loading");
                    if (e.response && e.response.data) {
                        Vue.set(funding_source, "errors", _.get(e, "response.data.errors", []));
                    }
                });
        },
    },
};
</script>

<style scoped></style>
